<template>
  <div :class="$style.root">
    <div :class="$style.list">
      <History
        :class="$style.history"
        v-for="history in histories"
        :key="history.id"
        :history="history"
      />
    </div>
    <div ref="bottom" :class="$style.bottom"></div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import History from '@/components/History/History'

export default {
  components: {
    History,
  },
  data () {
    return {
      bottomObserver: null,
      histories: [],
      page: 0,
      eol: false,
      isLoading: false,
      isBottom: false,
    }
  },
  mounted () {
    this.downloadHistories()
    this.initIntxObserver()
  },
  beforeDestroy () {
    this.destroyIntxObserver()
  },
  methods: {
    initIntxObserver () {
      const intxCb = (entries) => {
        if (entries.length == 0) {
          return
        }
        const e = entries[0]
        if (e.isIntersecting && !this.eol) {
          this.downloadHistories()
        }
      }
      this.bottomObserver = new IntersectionObserver(intxCb, {
        root: this.$el,
        threshold: 0.5,
      })
      this.bottomObserver.observe(this.$refs.bottom)
    },
    destroyIntxObserver () {
      this.bottomObserver.disconnect()
      this.bottomObserver = null
    },
    async downloadHistories () {
      this.isLoading = true
      try {
        const { data } = await this.httpGet({
          url: '/history',
          query: { page: this.page + 1 },
        })

        if (data.length == 0) {
          this.eol = true
        } else {
          this.histories = [ ...this.histories, ...data ]
        }
        this.page++
      } catch (e) {
        //
      } finally {
        this.isLoading = false
      }
    },
    ...mapActions('http', {
      httpGet: 'get',
    }),
  },
}
</script>

<style lang="scss" module>
.root {
  @apply h-full;
  @apply overflow-y-scroll;
}

.list {
  @apply px-4;
}

.history {
  @apply my-4;
}

.bottom {
  @apply -mt-4;
  @apply pt-2;
}
</style>
